<template>
	<v-snackbar v-model="alerta.estado" :timeout="3000" class="black--text" top multi-line
		:color="alerta.tipo == 'alerta'? 'warning': alerta.tipo == 'error' ? 'error': 'success'">
		<div class="text-center mx-auto">
			<h2>{{alerta.titulo}}</h2>
			<span>
				{{ alerta.info }}
			</span>
		</div>
		<v-btn color="black" icon @click="alerta.estado = false">
			<v-icon>mdi-close</v-icon>
		</v-btn>
	</v-snackbar>
</template>

<script>
	import {
		mapState
	} from 'vuex'

	export default {
		computed: {
			...mapState(['alerta', 'movil'])
		},
	}
</script>